import { Link } from "react-router-dom";
import "./Footer1.css";

const FOOTER_LINKS = [
  { label: "Markets", to: "/market" },
  { label: "About", to: "/" },
  { label: "Promotions", to: "/promotions" },
  { label: "My Account", to: "/account" },
];

const SOCIAL_LINKS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/",
    icon: "ti-brand-instagram",
  },
  {
    label: "Discord",
    href: "https://discord.com/",
    icon: "ti-brand-discord-filled",
  },
  { label: "X", href: "https://x.com/", icon: "ti-brand-x" },
];

const PARTNER_LOGOS = [
  { name: "Visa", src: "/assets/images/icon/visa.png" },
  { name: "Mastercard", src: "/assets/images/icon/mastercard.png" },
  { name: "Paysafecard", src: "/assets/images/icon/paysafecard.png" },
  { name: "Skrill", src: "/assets/images/icon/skrill.png" },
  { name: "Neteller", src: "/assets/images/icon/neteller.png" },
  { name: "Maestro", src: "/assets/images/icon/maestro.png" },
  { name: "WebMoney", src: "/assets/images/icon/webmoney.png" },
  { name: "NetEnt", src: "/assets/images/icon/netent.png" },
  { name: "Play'n GO", src: "/assets/images/icon/play-go.png" },
  { name: "Gamomat", src: "/assets/images/icon/gamomat.png" },
];

function PartnerLogoGroup({ hidden = false }) {
  return (
    <div className="compact-footer__partner-group" aria-hidden={hidden}>
      {PARTNER_LOGOS.map((partner) => (
        <div className="compact-footer__partner" key={partner.name}>
          <img src={partner.src} alt={hidden ? "" : partner.name} />
        </div>
      ))}
    </div>
  );
}

const Footer1 = () => {
  return (
    <footer className="compact-footer" id="footer">
      <div className="compact-footer__inner">
        <div className="compact-footer__main">
          <Link className="compact-footer__brand" to="/market">
            <img src="/assets/images/logo.png" alt="IntPulse" />
            <span>IntPulse</span>
          </Link>

          <nav className="compact-footer__links" aria-label="Footer navigation">
            {FOOTER_LINKS.map((link) => (
              <Link key={link.label} to={link.to}>
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="compact-footer__socials" aria-label="Social links">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.label}
                title={social.label}
              >
                <i className={`ti ${social.icon}`} aria-hidden="true"></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      <section
        className="compact-footer__partners"
        aria-label="Partners and affiliations"
      >
        <div className="compact-footer__partner-label">
          Partners &amp; integrations
        </div>
        <div className="compact-footer__marquee">
          <div className="compact-footer__partner-track">
            <PartnerLogoGroup />
            <PartnerLogoGroup hidden />
          </div>
        </div>
      </section>

      <div className="compact-footer__inner">
        <div className="compact-footer__bottom">
          <span>&copy; {new Date().getFullYear()} IntPulse</span>
          <span>Market predictions involve risk. Participate responsibly.</span>
          <span className="compact-footer__age">18+</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer1;